export default { "type": "FeatureCollection", "features": [
        { "type": "Feature", "geometry": { "type": "Polygon", "coordinates": [[[-76.932, 38.91], [-76.91, 38.893], [-76.992, 38.829], [-77.02, 38.813], [-77.026, 38.827], [-77.022, 38.871], [-77.057, 38.901], [-77.093, 38.907], [-77.121, 38.934], [-77.041, 38.995], [-76.932, 38.91]]] }, "properties": { "name": "Washington, District of Columbia", "id": "11001", "STATE": "DC", "TYPE": "Federal District", "CNTRY": "USA" }, "id": "11001" }
    ] };



//////////////////
// WEBPACK FOOTER
// ../geodata/es2015/region/usa/dcLow.js
// module id = null
// module chunks = 